
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/exclusive-playlist/[playlistId]",
      function () {
        return require("private-next-pages/d/exclusive-playlist/[playlistId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/exclusive-playlist/[playlistId]"])
      });
    }
  